import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


export const dropdownList = {
	VyrobekndOzn: [],
	PartsLists: [],
};

export const edit = {
	Text: null as string | null,
	NdNr: null as number | null,
	VyrobekndOzn: null as number | null,
	PcPevna: null as number | null,
	Poznamka2Dd: null as string | null,
	MnozstviSj: null as number | null,
	Pc: null as number | null,
	Sleva: null as number | null,
	MnozstviDodano: null as number | null,
	MnozstviSjKor: null as number | null,
	PcSpec: null as string | null,
	VstupDat: null as string | null,
	VstupPracId: null as number | null,
	EditDat: null as string | null,
	EditPracIdText: null as string | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames: [],
	depTableSettings: {},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
	},
});
